import PropTypes from 'prop-types'
import classNames from 'classnames'
import { ReactComponent as ArrowLeftSvg } from '../../../assets/svg/arrow-left.svg'

const propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  onBackButtonClicked: PropTypes.func,
  className: PropTypes.string,
}

const PageHeading = ({
  title,
  description,
  onBackButtonClicked = null,
  className,
}) => {
  return (
    <div
      className={classNames(
        'd-flex justify-content-between align-items-center',
        className
      )}
    >
      {onBackButtonClicked ? (
        <button
          type='button'
          className='clickable border-0 d-flex align-items-center justify-content-center'
          style={{ background: '#F7F7F7', borderRadius: '22px', width: '27px', height: '27px' }}
          aria-label='Go back'
          onClick={onBackButtonClicked}
        >
          <ArrowLeftSvg width={16} />
        </button>
      ) : (
        <div />
      )}

      {title && (
        <div className='d-flex justify-content-center flex-column'>
          <h5 style={{ color: '#101828' }} className='fw-semibold'>
            {title}
          </h5>

          {description && (
            <div style={{ color: '#667085' }} className='fw-medium text-sm'>
              {description}
            </div>
          )}
        </div>
      )}
      <div />
    </div>
  )
}

PageHeading.propTypes = propTypes

export default PageHeading
